function FPDialog() {

    var $ = jQuery;

    var FLASH_MESSAGE = '<div class="FPDialog dialog">' +
        '<p class="MESSAGE1">Для начала игры нужно запустить Flash-плеер</p>' +
        '<span class="img"></span>' +
        '<a href="//get.adobe.com/flashplayer/" target="_top" class="button RUN">Запустить!</a>' +
        '</div>';

    var FLASH_ALLOW = '<div class="flash-allow">' +
        '<p class="ALLOW">Нажмите "Разрешить" в появивившемся диалоговом окне.</p>' +
        '<p class="append ENABLE1">Если окно не появилось, перейдите в настройки по адресу</p>' +
        '<p class="append code ENABLE2">chrome://settings/content/flash</p>' +
        '<p class="append ENABLE3">Отключите настройку “Запретить сайтам запускать Flash”, после чего нажмите кнопку "Запустить!" ещё раз.</p>' +
        '</div>';

    function build(template, messages) {
        var element = $(template);
        messages.forEach(function (id) {
            element.find('.' + id).text(L10N.getString('FP_DIALOG_' + id));
        });
        return element;
    }

    var flashMessage = build(FLASH_MESSAGE, ['MESSAGE1', 'RUN']);
    var flashAllow = build(FLASH_ALLOW, ['ALLOW', 'ENABLE1', 'ENABLE2', 'ENABLE3']);

    flashMessage.find('.button').click(function () {
        flashMessage.addClass('expanded').append(flashAllow);
    });

    return flashMessage;

}